export default "__VITE_ASSET__D3JRefBf__"